/**
 * @generated SignedSource<<ffd4ee3cc31560fccdd6796324ef60c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PhaseItemTooltipBudgetSectionQuery$variables = {
  phaseId: number;
  projectId: number;
};
export type PhaseItemTooltipBudgetSectionQuery$data = {
  readonly projects_by_pk: {
    readonly actuals: ReadonlyArray<{
      readonly billable_minutes: number | null | undefined;
      readonly date: string | null | undefined;
      readonly id: number;
      readonly nonbillable_minutes: number | null | undefined;
      readonly person_id: number;
      readonly phase_id: number | null | undefined;
      readonly project_id: number;
      readonly role_id: number;
      readonly workstream_id: number | null | undefined;
    }>;
    readonly assignments: ReadonlyArray<{
      readonly end_date: string | null | undefined;
      readonly id: number;
      readonly is_billable: boolean | null | undefined;
      readonly minutes_per_day: number;
      readonly non_working_day: boolean;
      readonly person_id: number;
      readonly phase_id: number | null | undefined;
      readonly project_id: number;
      readonly role_id: number;
      readonly start_date: string | null | undefined;
      readonly workstream_id: number | null | undefined;
    }>;
    readonly budget_method: any;
    readonly id: number;
    readonly is_template: boolean;
    readonly members: ReadonlyArray<{
      readonly id: number;
      readonly person: {
        readonly contracts: ReadonlyArray<{
          readonly cost: number | null | undefined;
          readonly end_date: string | null | undefined;
          readonly padded_cost: number | null | undefined;
          readonly start_date: string | null | undefined;
        }>;
        readonly id: number;
        readonly is_placeholder: boolean;
        readonly time_offs: ReadonlyArray<{
          readonly end_date: string | null | undefined;
          readonly id: number;
          readonly leave_type: string;
          readonly minutes_per_day: number | null | undefined;
          readonly start_date: string | null | undefined;
        }>;
      };
    }>;
    readonly other_costs: ReadonlyArray<{
      readonly charge: number | null | undefined;
      readonly cost: number | null | undefined;
      readonly date: string | null | undefined;
      readonly id: number;
      readonly phase_id: number | null | undefined;
    }>;
    readonly phase_roles: ReadonlyArray<{
      readonly estimated_minutes: number | null | undefined;
      readonly id: number;
      readonly phase_id: number | null | undefined;
      readonly role_id: number;
    }>;
    readonly phases: ReadonlyArray<{
      readonly id: number;
      readonly revenue_budget: number | null | undefined;
    }>;
    readonly pricing_model: string;
    readonly project_rates: ReadonlyArray<{
      readonly id: number;
      readonly rate: number | null | undefined;
      readonly role_id: number;
    }>;
    readonly project_roles: ReadonlyArray<{
      readonly estimated_minutes: number | null | undefined;
      readonly id: number;
      readonly role_id: number;
    }>;
    readonly rate_card: {
      readonly blended_rate: number | null | undefined;
      readonly blended_rate_card: boolean;
      readonly id: number;
      readonly name: string | null | undefined;
      readonly role_charge_out_rates: ReadonlyArray<{
        readonly charge_out_rate: number | null | undefined;
        readonly rate_card_id: number;
        readonly role_id: number;
      }>;
    };
    readonly summary: ReadonlyArray<{
      readonly actual_phase_id: number | null | undefined;
      readonly minutes_phase_id: number | null | undefined;
      readonly role_id: number | null | undefined;
      readonly total_billable_minutes: number | null | undefined;
    }>;
    readonly total_budget: number | null | undefined;
  } | null | undefined;
};
export type PhaseItemTooltipBudgetSectionQuery = {
  response: PhaseItemTooltipBudgetSectionQuery$data;
  variables: PhaseItemTooltipBudgetSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phaseId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase_id",
  "storageKey": null
},
v6 = {
  "alias": "date",
  "args": null,
  "kind": "ScalarField",
  "name": "date_runn",
  "storageKey": null
},
v7 = {
  "alias": "cost",
  "args": null,
  "kind": "ScalarField",
  "name": "cost_private",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v11 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v12 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "projectId"
      }
    ],
    "concreteType": "projects",
    "kind": "LinkedField",
    "name": "projects_by_pk",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "is_template",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget_method",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "project_rates",
        "kind": "LinkedField",
        "name": "project_rates",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": "rate",
            "args": null,
            "kind": "ScalarField",
            "name": "rate_private",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "rate_cards",
        "kind": "LinkedField",
        "name": "rate_card",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": "blended_rate",
            "args": null,
            "kind": "ScalarField",
            "name": "blended_rate_private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blended_rate_card",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "role_charge_out_rates",
            "kind": "LinkedField",
            "name": "role_charge_out_rates",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate_card_id",
                "storageKey": null
              },
              {
                "alias": "charge_out_rate",
                "args": null,
                "kind": "ScalarField",
                "name": "charge_out_rate_private",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "project_roles",
        "kind": "LinkedField",
        "name": "project_roles",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "phases",
        "kind": "LinkedField",
        "name": "phases",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": "revenue_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "revenue_budget_private",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "_eq",
                    "variableName": "phaseId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "phase_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "phase_roles",
        "kind": "LinkedField",
        "name": "phase_roles",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "v_summary_total",
        "kind": "LinkedField",
        "name": "summary",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutes_phase_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total_billable_minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actual_phase_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "order_by",
            "value": {
              "date": "asc"
            }
          }
        ],
        "concreteType": "other_costs",
        "kind": "LinkedField",
        "name": "other_costs",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          {
            "alias": "charge",
            "args": null,
            "kind": "ScalarField",
            "name": "charge_private",
            "storageKey": null
          },
          (v7/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricing_model",
        "storageKey": null
      },
      {
        "alias": "total_budget",
        "args": null,
        "kind": "ScalarField",
        "name": "total_budget_private",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "actuals",
        "kind": "LinkedField",
        "name": "actuals",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billable_minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nonbillable_minutes",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "assignments",
        "kind": "LinkedField",
        "name": "assignments",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_billable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "non_working_day",
            "storageKey": null
          },
          (v5/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "project_members",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_placeholder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "contracts",
                "kind": "LinkedField",
                "name": "contracts",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": "padded_cost",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cost_padded_private",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "time_offs",
                "kind": "LinkedField",
                "name": "time_offs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "leave_type",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "selections": (v14/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "c5b4c8e1d0251e88941b067cf329027e",
    "id": null,
    "metadata": {},
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "operationKind": "query",
    "text": "query PhaseItemTooltipBudgetSectionQuery(\n  $projectId: Int!\n  $phaseId: Int!\n) {\n  projects_by_pk(id: $projectId) {\n    id\n    is_template\n    budget_method\n    project_rates {\n      id\n      role_id\n      rate: rate_private\n    }\n    rate_card {\n      id\n      name\n      blended_rate: blended_rate_private\n      blended_rate_card\n      role_charge_out_rates {\n        role_id\n        rate_card_id\n        charge_out_rate: charge_out_rate_private\n      }\n    }\n    project_roles {\n      id\n      role_id\n      estimated_minutes\n    }\n    phases {\n      id\n      revenue_budget: revenue_budget_private\n    }\n    phase_roles(where: {phase_id: {_eq: $phaseId}}) {\n      id\n      phase_id\n      role_id\n      estimated_minutes\n    }\n    summary {\n      role_id\n      minutes_phase_id\n      total_billable_minutes\n      actual_phase_id\n    }\n    other_costs(order_by: {date: asc}) {\n      id\n      date: date_runn\n      charge: charge_private\n      cost: cost_private\n      phase_id\n    }\n    pricing_model\n    total_budget: total_budget_private\n    actuals {\n      id\n      date: date_runn\n      billable_minutes\n      nonbillable_minutes\n      person_id\n      project_id\n      role_id\n      phase_id\n      workstream_id\n    }\n    assignments {\n      id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      minutes_per_day\n      person_id\n      project_id\n      role_id\n      is_billable\n      non_working_day\n      phase_id\n      workstream_id\n    }\n    members {\n      id\n      person {\n        id\n        is_placeholder\n        contracts {\n          start_date: start_date_runn\n          end_date: end_date_runn\n          cost: cost_private\n          padded_cost: cost_padded_private\n        }\n        time_offs {\n          id\n          start_date: start_date_runn\n          end_date: end_date_runn\n          minutes_per_day\n          leave_type\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b1372de91ce481d590d9d70d2882319";

export default node;
